import cloneDeep from 'clone';
import deepMerge from 'merge';

export default class Saver {
  constructor(router, options = {}) {
    this.router = router;
    const defaultOptions = { storageName: 'saved-filters' };
    this.options = deepMerge(defaultOptions, options);
  }

  setOptions(options) {
    this.options = deepMerge(this.options, options);
  }

  saveToUrl(params) {
    const route = this.router.match(location.pathname + location.search);
    let newQuery = cloneDeep(params);
    if (this.options.queryParameter) {
      newQuery = {
        [this.options.queryParameter]: newQuery
      };
    }

    this.router.push({
      name: route.name,
      query: {
        ...route.query,
        ...newQuery
      }
    });
  }

  getFromUrl() {
    const route = this.router.match(location.pathname + location.search);
    let query = null;

    if (this.options.queryParameter) {
      query = route.query[this.options.queryParameter] || {};
    } else {
      query = route.query;
    }
    return Object.getOwnPropertyNames(query).length === 0 ? null : query;
  }

  static namespace = 'saver_';

  static saveToLocalStorage(name, params) {
    localStorage.setItem(this.namespace + name, JSON.stringify(params));
  }

  static readFromLocalStorage(name) {
    return JSON.parse(localStorage.getItem(this.namespace + name));
  }

  static deleteFromLocalStorage(name) {
    return localStorage.removeItem(this.namespace + name);
  }
}
